import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { UsersListWrapper } from './garage/users-list/UsersList'
import { useAuth } from '../../modules/auth'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]


const Garage = () => {

  const {currentUser} = useAuth();

  return (
    <Routes>
      <Route element={<Outlet />}>
     
        <Route
          path='garages'
          element={
            <>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Garage Listing</PageTitle>
              {currentUser?.permissions.find((item: any) => true) ?
              <UsersListWrapper />  : <h1>You Are Not Allowed</h1> }
              {/* <ManageUser /> */}
              {/* <TablesWidget10 className={''} /> */}
            </>
          }
        />
       
      </Route>
      <Route index element={<Navigate to='/admin/garage-management/garages' />} />
    </Routes>
  )
}

export default Garage
